import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getToolbarUtilityClass(slot: string) {
  return generateUtilityClass('O2Popper', slot);
}

const popperClasses = generateUtilityClasses('O2Popper', ['root', 'paper']);

export default popperClasses;
